import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Depost } from "./components/depost";
import { Newbie } from "./components/newbie";
import { Increase } from "./components/increase";
import { Level } from "./components/level";
import { Friends } from "./components/friends";
import { Feature } from "./components/feature";
import { Services } from "./components/services";
import { Privacy } from "./components/privacy";
import { Rules } from "./components/rules";
import { Mycard } from "./components/mycard";
import { Hotgame } from "./components/hotgame";
import { Swiperimg } from "./components/swiperimg";
import { Shortcut } from "./components/shortcut";
import { Contact } from "./components/contact";
import { trackPageView } from "./tracking/track";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import AOS from 'aos';
import "./App.css";
import 'aos/dist/aos.css'; // AOS 樣式文件

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// 初始化 AOS
AOS.init();

// 解析 URL 中的 _ads 參數
function parseCurrentUriAds() {
  try {
    const url = new URL(window.location.href);
    const adsValue = url.searchParams.get("_ads"); // 使用 searchParams.get 更可靠
    return adsValue || null; // 如果沒有 _ads，返回 null
  } catch (error) {
    console.error("Error parsing URL:", error.message);
    return null;
  }
}

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [adsValue, setAdsValue] = useState(null);
  const [currentPage, setCurrentPage] = useState("home"); // Add state for current page

  useEffect(() => {
    setLandingPageData(JsonData); // 確保數據始終加載
    trackPageView();
    const adsStr = parseCurrentUriAds();
    console.log("parseCurrentUriAds:", adsStr); // 檢查 ads 值
    setAdsValue(adsStr);

    // Check URL path to determine which page to show
    const path = window.location.pathname;
    if (path === "/services") {
      setCurrentPage("services");
    } else if (path === "/privacy") {
      setCurrentPage("privacy");
    } else if (path === "/gamerule") {
      setCurrentPage("gamerule");
    } else if (path === "/mycard") {
      setCurrentPage("mycard");
    } else if (path === "/home" || path === "/") {
      setCurrentPage("home"); // 新增一個 404 狀態
    } else {
      setCurrentPage("notfound"); // 新增一個 404 狀態
    }

  }, []);

  // 添加條件渲染，確保數據加載前顯示載入中
  if (!landingPageData || Object.keys(landingPageData).length === 0) {
    return <div>Loading...</div>;
  }

  // Render different pages based on currentPage state
  const renderPage = () => {
    switch (currentPage) {
      case "services":
        return <Services data={landingPageData.Services} adsValue={adsValue} />;
      case "privacy":
        return <Privacy adsValue={adsValue} />;
      case "gamerule":
        return <Rules adsValue={adsValue} />;
      case "mycard":
        return <Mycard adsValue={adsValue} />;
      case "notfound":
        return <div style={{ textAlign: "center", padding: "50px" }}><h1>404 - Page Not Found</h1></div>;
      default:
        return (
          <>
            <Header data={landingPageData.Header} />
            <Newbie data={landingPageData.Newbie} />
            {/* <Increase data={landingPageData.Increase} /> */}
            <Level data={landingPageData.Level} />
            <Friends data={landingPageData.Friends} />
            <Hotgame data={landingPageData.Hotgame} />
            {/* <Swiperimg data={landingPageData.Swiperimg} /> */}
            <Feature data={landingPageData.Feature} />
            {/* <Depost data={landingPageData.Depost} /> */}
            <Shortcut data={landingPageData.Shortcut} />
            <Contact data={landingPageData.Contact} />
          </>
        );
    }
  };

  return (
    <div>
      <Navigation adsValue={adsValue} currentPage={currentPage} />
      {renderPage()}
    </div>
  );
};

export default App;